import { uniq } from 'lodash';

export default function() {
  return function(arr) {
    return uniq(arr);
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/Unique.js